(() => {
  if (typeof window.customElements.get('promo-banner') !== 'undefined') { return }
  window.customElements.define('promo-banner', class PromoBanner extends HTMLElement {
    constructor () {
      super()

      this.countdownContainer = this.querySelector('[data-promo-banner-countdown]')

      this.initCountdown()
      this.resizeObserver()
    }

    /**
     * Initialize the Countdown Timer
     * @returns false if container doesn't exist
     */
    initCountdown () {
      if (!this.countdownContainer) { return false }

      this.endDate = new Date(`${this.countdownContainer.getAttribute('data-promo-banner-countdown').replace(/-/g, '/')} GMT-0500`)
      this.daysEl = this.countdownContainer.querySelector('[data-promo-banner-countdown-days]')
      this.hoursEl = this.countdownContainer.querySelector('[data-promo-banner-countdown-hours]')
      this.minutesEl = this.countdownContainer.querySelector('[data-promo-banner-countdown-minutes]')
      this.secondsEl = this.countdownContainer.querySelector('[data-promo-banner-countdown-seconds]')

      setInterval(() => {
        const now = new Date().getTime()
        const difference = this.endDate - now
        let days = Math.floor(difference / (1000 * 60 * 60 * 24))
        let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        let seconds = Math.floor((difference % (1000 * 60)) / 1000)

        if (days < 0) {
          days = 0
        }

        if (hours < 0) {
          hours = 0
        }

        if (minutes < 0) {
          minutes = 0
        }

        if (seconds < 0) {
          seconds = 0
        }

        this.daysEl.innerHTML = days
        this.hoursEl.innerHTML = hours
        this.minutesEl.innerHTML = minutes
        this.secondsEl.innerHTML = seconds
      }, 1000)
    }

    /**
     * Observes resizes for sticky height calculations
     */
    resizeObserver () {
      this.sectionWrapper = this.closest('.shopify-section')

      document.documentElement.style.setProperty('--promo-banner-height', Math.round(this.sectionWrapper.clientHeight) + 'px');

      window.addEventListener('resize', () => {
        document.documentElement.style.setProperty('--promo-banner-height', Math.round(this.sectionWrapper.clientHeight) + 'px');
      })
    }
  })
})()
